<template>
  <div
    ref="sandImageHome"
    class="SandtableMap_container_RioDyL"
    v-if="visible && editSandtable.url"
    @click.stop="onclikcZoom('zoomin')"
  >
    <div
      ref="mapContainer"
      class="SandtableMap_map_2EvhYz"
      @mousemove="draging($event)"
      @mouseup="dragEnd($event)"
      @mouseleave="dragEnd($event)"
      @touchmove="draging($event)"
      @touchend="dragEnd($event)"
    >
      <!-- <div class="SandtableMap_imgContainer_1VsY8A" :style="mapStyle"></div> -->
      <img
        v-show="showImage"
        ref="sandImg"
        :style="{ maxWidth, maxHeight }"
        :src="editSandtable.url"
      />
      <div
        :ref="key + 'radar-control'"
        class="radar-control"
        v-for="(value, key) in editSandtable.scenes"
        :key="key"
        :style="{
          left: value.left,
          top: value.top,
          transform: `rotate(${getRadarRotate(value)}deg)`,
        }"
      >
        <!-- <img
          class="radar-control-img"
          src="../../static/images/kr/radar-out2.png"
          data-toggle="tooltip"
          title
          data-container="#panoSettingModal"
          ondragstart="return false;"
          v-if="showZoomOut && key != currentScenesId"
          @click.stop="handleRadarClick(key)"
        /> -->
        <img
          class="radar-control-img"
          src="../../static/images/kr/radar-out3.png"
          data-toggle="tooltip"
          title
          data-container="#panoSettingModal"
          ondragstart="return false;"
          v-if="showPoints && key != currentScenesId"
          @click.stop="handleRadarClick(key)"
        />
        <div class="radar-circle" v-show="key == currentScenesId">
          <!-- <div
            :ref="key+'radar-point'"
            class="radar-point"
            @mousedown.stop="rotateStart($event)"
            @touchstart.stop="rotateStart($event)"
          ></div> -->
          <div
            class="radar-center-point"
            @mousedown.stop="moveStart($event)"
            @touchstart.stop="moveStart($event)"
          ></div>
        </div>
      </div>
    </div>
    <!-- <div class="SandtableMap_zoombar_34UxhI">
        <a-icon type="zoom-in" />60%
        <a-icon type="zoom-out" />
    </div>-->
    <!-- <div class="tour-zoomForPublic" v-if="isShowZoom && !isZoomedIn" @click="onclikcZoom('zoomin')">
      <a-icon class="ant-icon" type="zoom-in" />{{$t('edit.zoomIn')}}
    </div>
    <div class="tour-zoomForPublic" v-if="isShowZoom && isZoomedIn" @click="onclikcZoom">
      <a-icon class="ant-icon" type="close-circle" />{{$t('message.collapseClose')}}
    </div> -->
    <div
      class="tour-zoomForPublic"
      v-if="isShowZoom && !isZoomedIn"
      @click.stop="setShowOutPoints"
    >
      {{ "顯示其他場景" }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isMobile, handleImageSize } from "../../static/js/utils/tools.js";

export default {
  name: "ToolDrawer",
  props: {
    mode: {
      type: String,
      default: "tour",
    },
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    // maxWidth: { default: "290px", type: String },
    // maxHeight: { default: "290px", type: String },
    // initWidth: { default: 290, type: Number },
    initHeight: { default: 290, type: Number },
    isShowZoom: { default: false, type: Boolean },
    showZoomOut: { default: false, type: Boolean },
  },
  data() {
    return {
      cloneSandtable: {},
      rotating: false,
      startRotate: 0,
      startHlookat: 0,
      center: [0, 0],
      point: [0, 0],
      moving: false,
      dragTime: 0,
      showImage: false,
      isZoomedIn: false, // 是否放大
      imageWidth: 0,
      imageHeight: 0,
      maxWidth: "290px",
      maxHeight: "290px",
      currentScenesId: undefined,
      currentHlookat: 0,
      initialScenesId: null,
      isShowOutPoints: this.$store.state.user.isShowOutPoints !== undefined 
      ? this.$store.state.user.isShowOutPoints 
      : false,
    };
  },
  computed: {
    ...mapGetters([
      "vrbase",
      //"currentScenesId",
      //"currentHlookat",
      "editSandtable",
    ]),
    isMobi() {
      return isMobile();
    },
    showPoints() {
      if (this.isZoomedIn) {
        return true;
      } else {
        return this.isShowOutPoints;
      }
    },
  },
  watch: {
    visible(value) {
      if (value) {
        console.log("===0===", value);
      }
    },
    editSandtable() {
      this.cloneSandtable = this.deepClone(this.editSandtable);
      console.log("模型變了===", this.cloneSandtable.url);
      this.getImageWH(); // 圖片變了要重新計算
    },
    initHeight() {
      this.getImageWH();
    },
    currentHlookat(newVal, oldVal) {
      //todo
    },
    currentScenesId(newVal, oldVal) {
      //todo
    },
  },
  created() {
    // this.cloneSandtable = this.deepClone(this.editSandtable);
    // this.isZoomedIn = this.showZoomOut
  },
  mounted() {
    this.cloneSandtable = this.deepClone(this.editSandtable);
    this.isZoomedIn = this.showZoomOut;
    this.getImageWH();
    let _this = this;
    window.syncSandTable = function (scene, hlookat) {
      if (_this.initialScenesId === null) {
        _this.initialScenesId = scene;
      }
      _this.currentScenesId = scene;
      _this.currentHlookat = hlookat;
    };
  },
  methods: {
    deepClone(obj) {
      let newObj = JSON.parse(JSON.stringify(obj));
      return newObj;
    },
    updateSandtable() {
      this.$store.commit("SET_EDIT_SANDTABLE", this.cloneSandtable);
    },
    getRadarRotate(scene) {
      return this.caculateRotate(
        this.currentHlookat - scene.hlookat + scene.rotate
      );
    },
    rotateStart(event) {
      this.rotating = true;
      this.startRotate = this.getRadarRotate(
        this.cloneSandtable.scenes[this.currentScenesId]
      );
      this.startHlookat = this.currentHlookat;
      this.startHlookatRotate =
        this.cloneSandtable.scenes[this.currentScenesId].rotate;
      let radarControl = this.$refs[this.currentScenesId + "radar-control"][0];
      let radarControlRect = radarControl.getBoundingClientRect();
      var cx = (radarControlRect.left + radarControlRect.right) / 2;
      var cy = (radarControlRect.top + radarControlRect.bottom) / 2;
      this.center = [cx, cy];

      let radarPoint = this.$refs[this.currentScenesId + "radar-point"][0];
      let radarPointRect = radarPoint.getBoundingClientRect();
      let px = (radarPointRect.left + radarPointRect.right) / 2;
      var py = (radarPointRect.top + radarPointRect.bottom) / 2;

      this.point = [px, py];
    },
    caculateRotate(inputRotate) {
      let rotate = inputRotate;
      while (rotate < -180 || rotate > 180) {
        if (rotate > 180) {
          rotate -= 360;
        }
        if (rotate < -180) {
          rotate += 360;
        }
      }

      return rotate;
    },
    moveStart(event) {
      if (this.mode == "edit") {
        this.moving = true;
      }
    },
    getYAngle(px, py, mx, my) {
      //獲得人物中心和鼠標坐標連線，與y軸正半軸之間的夾角
      var x = Math.abs(px - mx);
      var y = Math.abs(py - my);
      var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
      var cos = y / z;
      var radina = Math.acos(cos); //用反三角函數求弧度
      var angle = Math.floor(180 / (Math.PI / radina)); //將弧度轉換成角度

      if (mx > px && my > py) {
        //鼠標在第四象限
        angle = 180 - angle;
      }

      if (mx == px && my > py) {
        //鼠標在y軸負方向上
        angle = 180;
      }

      if (mx > px && my == py) {
        //鼠標在x軸正方向上
        angle = 90;
      }

      if (mx < px && my > py) {
        //鼠標在第三象限
        angle = 180 + angle;
      }

      if (mx < px && my == py) {
        //鼠標在x軸負方向
        angle = 270;
      }

      if (mx < px && my < py) {
        //鼠標在第二象限
        angle = 360 - angle;
      }

      return angle;
    },
    draging(event) {
      let mouseX, mouseY;
      if (event.type == "touchmove") {
        mouseX = event.touches[0].clientX;
        mouseY = event.touches[0].clientY;
      } else {
        mouseX = event.clientX;
        mouseY = event.clientY;
      }
      if (this.rotating) {
        let mouseAngleY = this.getYAngle(
          this.center[0],
          this.center[1],
          mouseX,
          mouseY
        );
        let pointAngleY = this.getYAngle(
          this.center[0],
          this.center[1],
          this.point[0],
          this.point[1]
        );

        let angleOffset = mouseAngleY - pointAngleY;
        console.log("偏移角度" + angleOffset);
        if (this.mode == "edit") {
          this.cloneSandtable.scenes[this.currentScenesId].rotate =
            this.startHlookatRotate + angleOffset;
          this.updateSandtable();
        } else {
          let lookath = this.startHlookat + angleOffset;
          setHlookat(lookath);
        }
      }
      if (this.moving) {
        let mapX = this.$refs.mapContainer.getBoundingClientRect().left;
        let mapY = this.$refs.mapContainer.getBoundingClientRect().top;
        let mapWidth = this.$refs.mapContainer.offsetWidth;
        let mapHeight = this.$refs.mapContainer.offsetHeight;

        this.cloneSandtable.scenes[this.currentScenesId].left = `${
          Math.abs((mouseX - mapX) / mapWidth) * 100
        }%`;
        this.cloneSandtable.scenes[this.currentScenesId].top = `${
          Math.abs((mouseY - mapY) / mapHeight) * 100
        }%`;

        this.updateSandtable();
      }
    },
    dragEnd(event) {
      this.rotating = false;
      this.moving = false;
    },
    handleRadarClick(sceneId) {
      this.$store.dispatch("loadScene", sceneId);
    },
    getImageWH() {
      const imgWH = {};
      let img = new Image();
      img.src = this.editSandtable.url;
      img.onload = () => {
        this.imageWidth = img.width;
        this.imageHeight = img.height;
        this.resizeTheImage();
      };
      img.οnerrοr = function () {
        console.log("==image error==");
      };
    },
    resizeTheImage() {
      const ratio = this.imageWidth / this.imageHeight;
      const config = {
        ratio,
        initWidth: this.initHeight,
        initHeight: this.initHeight,
        isFullScreen: this.showZoomOut,
        isEdit: this.mode === "edit",
      };
      const { height, width } = handleImageSize(config);
      this.maxHeight = height;
      this.maxWidth = width;
      this.showImage = true;
    },
    onclikcZoom(type) {
      console.log(this.imageWidth, this.imageHeight);
      if ("zoomin" === type) {
        this.isZoomedIn = true;
        this.$emit("sandTableZoomIn", true, this.imageWidth / this.imageHeight);
      } else {
        this.$emit(
          "sandTableZoomIn",
          false,
          this.imageWidth / this.imageHeight
        );
        this.isZoomedIn = false;
      }
    },
    setShowOutPoints() {
      this.isShowOutPoints = !this.isShowOutPoints;
      this.$store.commit("SET_IS_SHOW_OUT_POINTS", this.isShowOutPoints);
    },
  },
};
</script>

<style lang="less" scoped>
.SandtableMap_container_RioDyL {
  width: 100%;
  height: 100%;
}
.center {
  transform: translate(-50%, 0);
  left: 50%;
}

.SandtableMap_map_2EvhYz {
  position: relative;
  background-color: #ddd;
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 100%;
}
.SandtableMap_imgContainer_1VsY8A {
  -webkit-transform-origin: top left;
  -ms-transform-origin: top left;
  transform-origin: top left;
  cursor: -webkit-grab;
  cursor: grab;
}

.SandtableMap_zoombar_34UxhI {
  position: absolute;
  top: 20px;
  left: 50%;
  margin-right: -50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 75px;
  height: 25px;
  padding: 0 5px;
  background-color: rgba(52, 52, 52, 0.6);
  border-radius: 13px;
  border: 1px solid #343434;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.tour-zoomForPublic {
  position: absolute;
  z-index: 3001;
  overflow: visible;
  opacity: 1;
  cursor: pointer;
  pointer-events: auto;
  // background: url(../../../public/static/images/mapZoom.png);
  border-style: solid;
  background-size: 100% 100%;
  border-color: rgba(0, 0, 0, 0.3);
  border-width: 1px;
  border-radius: 14px;
  width: 85px;
  height: 28px;
  bottom: -33px;
  font-size: 12px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  // transform: translate(-50%, 0);
  // left: 50%;
  right: 0;
  user-select: none;
}
.tour-zoomForPublic .ant-icon {
  font-size: 14px;
  color: #ffffff;
  margin-right: 4px;
}

@media screen and (max-width: 768px) {
  .tour-zoomForPublic {
    border-radius: 14px;
    width: 85px;
    height: 28px;
    bottom: -32px;
    font-size: 11px;
  }
  .tour-zoomForPublic .ant-icon {
    fontsize: 11px;
  }
}
</style>
 